import React, { useEffect, useRef } from 'react';
import { getApiUrl } from '../config';
import '../styles/components/LoginPage.css';

/**
 * Компонент страницы входа с кнопкой Telegram Login
 * 
 * @param {Object} props - Свойства компонента
 * @param {Function} props.onLoginSuccess - Функция, вызываемая при успешной аутентификации
 * @param {String} props.debugInfo - Отладочная информация
 */
const LoginPage = ({ onLoginSuccess, debugInfo }) => {
  // Создаем реф для контейнера виджета
  const telegramBtnRef = useRef(null);

  useEffect(() => {
    // Создаем переменную для хранения текущего значения ref
    const telegramBtnContainer = telegramBtnRef.current;
    
    // Объявляем глобальную функцию для обработки авторизации
    window.onTelegramAuth = (user) => {
      console.log('Получены данные пользователя от Telegram:', user);
      
      // Отправляем данные на сервер для проверки и авторизации
      const sendAuthDataToServer = async (userData) => {
        try {
          // Преобразуем объект в FormData для отправки
          const formData = new FormData();
          Object.keys(userData).forEach(key => {
            formData.append(key, userData[key]);
          });
          
          // Отправляем запрос на сервер
          const response = await fetch(getApiUrl('/api/auth/telegram/callback'), {
            method: 'POST',
            body: formData,
            credentials: 'include' // Важно для сохранения сессионных cookie
          });
          
          // Проверяем ответ
          if (!response.ok) {
            throw new Error(`Ошибка авторизации: ${response.status}`);
          }
          
          // Получаем данные ответа
          const data = await response.json();
          console.log('Ответ сервера:', data);
          
          // Вызываем callback для обработки успешного входа
          if (data.status === 'ok' && onLoginSuccess) {
            onLoginSuccess(data);
          } else {
            throw new Error('Неверный формат ответа от сервера');
          }
        } catch (error) {
          console.error('Ошибка при авторизации:', error);
          alert(`Ошибка при входе через Telegram: ${error.message}`);
        }
      };
      
      // Вызываем функцию отправки данных
      sendAuthDataToServer(user);
    };

    // Вставляем скрипт Telegram Login Widget вручную
    if (telegramBtnContainer) {
      // Очищаем контейнер (если вдруг что-то было)
      telegramBtnContainer.innerHTML = '';
      
      // Создаём элемент скрипта
      const script = document.createElement('script');
      script.src = 'https://telegram.org/js/telegram-widget.js?22';
      script.async = true;
      script.setAttribute('data-telegram-login', 'BroCircleBot');
      script.setAttribute('data-size', 'large');
      script.setAttribute('data-onauth', 'onTelegramAuth(user)');
      script.setAttribute('data-request-access', 'write');
      
      // Добавляем скрипт в контейнер
      telegramBtnContainer.appendChild(script);
    }

    // Очистка при размонтировании компонента
    return () => {
      // Удаляем глобальную функцию
      delete window.onTelegramAuth;
      
      // Очищаем контейнер, если он все еще существует
      if (telegramBtnContainer) {
        telegramBtnContainer.innerHTML = '';
      }
    };
  }, [onLoginSuccess]);
  
  return (
    <div className="mobile-screen">
      <div className="screen-content">
        <h1>VINCLE</h1>
        <p>
          Добро пожаловать в VINCLE! Пожалуйста, войдите через Telegram для доступа к приложению.
        </p>
        
        {/* Контейнер для виджета Telegram Login */}
        <div className="card" style={{ padding: '30px 20px', textAlign: 'center', marginTop: '20px' }}>
          <div ref={telegramBtnRef} id="telegram-login-container"></div>
          
          {/* Для отладки отображаем сообщение, если кнопка не загрузилась */}
          <div style={{marginTop: '20px', display: 'none'}}>
            <p className="subtle-text">Если кнопка "Войти с Telegram" не отображается, перезагрузите страницу.</p>
          </div>
        </div>
        
        <p className="subtle-text" style={{ marginTop: '20px', textAlign: 'center' }}>
          Используя кнопку выше, вы соглашаетесь с условиями использования сервиса и политикой конфиденциальности.
        </p>

        {/* Кнопка для тестирования ручного вызова API */}
        <div className="card" style={{ marginTop: '30px', padding: '20px' }}>
          <h2>Возникли проблемы с входом?</h2>
          <p>Попробуйте открыть <a href="/telegram_test.html" target="_blank" rel="noopener noreferrer" style={{color: 'var(--accent-primary)'}}>тестовую страницу входа</a></p>
        </div>
        
        {/* Отладочная информация */}
        {/* {debugInfo && (
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: '10px', textAlign: 'left', background:'#f0f0f0', padding:'5px', marginTop: '20px', maxHeight: '300px', overflowY: 'auto', borderRadius: 'var(--base-border-radius)' }}>
            {debugInfo}
          </pre>
        )} */}
      </div>
    </div>
  );
};

export default LoginPage; 